import { parseQueryArguments } from '@/shared'
import {
    ITableListModel,
    TABLE_REQUEST_MODE,
    TableListRequestType,
    countData,
    deleteData,
    getData,
    patchData,
    postData,
} from '../utils/db'
import { TInTableColumn } from './inTableColumn'

export type TInDataList = {
    _id: string
    excel: string
    sheets: TInTableColumn[]
}

export default class InDataListModel implements ITableListModel<TInDataList> {
    constructor() { }

    public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, project, page = 0, limit = 10, q = '' }: TableListRequestType) {
        let query = parseQueryArguments(`page=${page}&limit=${limit}`, arguments)
        if (q) query += '&q=' + encodeURI(q)
        if (mode == TABLE_REQUEST_MODE.POSITION) {
            query += '&mode=position'
        }
        return await getData(`/projects/${project}/in?${query}`)
    }

    public async read(project: string, id: string) {
        return await getData(`/projects/${project}/in/${id}`)
    }

    public async create(project: string, data: any) {
        return await postData(`/projects/${project}/in`, data)
    }

    public async update(project: string, id: string, data: any) {
        return await patchData(`/projects/${project}/in/${id}`, data)
    }

    public async delete(project: string, id: string) {
        return await deleteData(`/projects/${project}/in/${id}`)
    }

    public async count(project: string) {
        return await countData(`/projects/${project}/in/count`)
    }

    public async checkUpload(project: string, data: any, options = {}) {
        return await postData(`/projects/${project}/in/check`, data, options)
    }

    public async readDataList({
        mode = TABLE_REQUEST_MODE.PAGINATION,
        project,
        dataList,
        page = 0,
        limit = 10,
        q = '',
    }: TableListRequestType) {
        let query = `page=${page}&limit=${limit}&q=${q}`
        if (mode == TABLE_REQUEST_MODE.POSITION) {
            query += '&mode=position'
        }
        return await getData(`/projects/${project}/in/data/${dataList}?${query}`)
    }
}
